import { render, staticRenderFns } from "./twoIndex.vue?vue&type=template&id=0ce61d99"
import script from "./twoIndex.vue?vue&type=script&lang=js"
export * from "./twoIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports